import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '@environments/environment';
import { AccountService } from '@app/_services';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
    const accountService = inject(AccountService);
    const account = accountService.accountValue;
    const isLoggedIn = account?.jwtToken;
    const isApiUrl = req.url.startsWith(environment.apiUrl);
    if (isLoggedIn && isApiUrl) {
        req = req.clone({ setHeaders: { Authorization: `Bearer ${account.jwtToken}` } });
    }
    return next(req);
};